import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@codex/themes';
import ComparePopupContent from './ComparePopupContent';
import BottomPopup from './BottomPopup/BottomPopup';
import { toggleComparePopup } from '../../../appState/ducks/compareProducts';

const ComparePanelPopup = (props) => {
  const { visibility, compareProductList, loading } = props.compareProducts;
  const productListLength = () => !loading && Object.entries(compareProductList).length;
  const handleVisibilty = (isVisible) => {
    props.toggleComparePopup(isVisible);
  };

  return (
    <div id={'compare-popup-section'}>
      {visibility && (
        <ThemeProvider theme={themes.currys}>
          <BottomPopup
            visible={(visibility && loading) || (productListLength() !== 0)}
            setVisible={handleVisibilty}
            title={`Compare Products (${productListLength() || 0} of 4)`}
          >
            <ComparePopupContent compareProductList={compareProductList} loading={loading} />
          </BottomPopup>
        </ThemeProvider>
      )}
    </div>
  );
};

ComparePanelPopup.propTypes = {
  toggleComparePopup: PropTypes.func.isRequired,
  compareProducts: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    visibility: PropTypes.bool.isRequired,
    compareProductList: PropTypes.objectOf(PropTypes.array)
  }).isRequired
};

const mapStateToProps = (state) => ({
  compareProducts: state.compareProducts
});

export default connect(mapStateToProps, { toggleComparePopup })(ComparePanelPopup);
